import React, { useState, useEffect } from 'react';
import './ios.css';
import Mapa from './components/Mapa';
import Cadastro from './components/Cadastro';
import Equipamentos from './components/Equipamentos';
import Configuracoes from './components/Configuracoes';
import Historico from './components/Historico';
import Relatorio from './components/Relatorio';
import Login from './components/Login';
import Notificacoes from './components/Notificacoes';
import { getConfiguracoes, getNotificacoes } from './services/api';

function NavBtn({ children, onClick }) {
    const [hover, setHover] = useState(false);
    return (
        <button
            onClick={onClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                background: hover ? 'rgba(0,122,255,0.1)' : 'transparent',
                color: hover ? '#007aff' : '#3a3a3c',
                border: 'none', borderRadius: 8, padding: '6px 13px',
                cursor: 'pointer', fontSize: 14, fontWeight: 500,
                fontFamily: 'var(--ios-font)', transition: 'all 0.15s',
                display: 'flex', alignItems: 'center', gap: 6,
            }}
        >
            {children}
        </button>
    );
}

export default function App() {
    const [usuario, setUsuario] = useState(null);
    const [showCadastro, setShowCadastro] = useState(false);
    const [showEquipamentos, setShowEquipamentos] = useState(false);
    const [showConfiguracoes, setShowConfiguracoes] = useState(false);
    const [showHistorico, setShowHistorico] = useState(false);
    const [showRelatorio, setShowRelatorio] = useState(false);
    const [configuracao, setConfiguracao] = useState({ nome_plataforma: 'Sigatron', logo_base64: null });
    const [showNotificacoes, setShowNotificacoes] = useState(false);
    const [pendentes, setPendentes] = useState(0);
    const pendentesRef = React.useRef(0);

    const carregarConfiguracao = async () => {
        try {
            const res = await getConfiguracoes();
            const cfg = res.data;
            setConfiguracao(cfg);
            // Atualiza título da aba
            document.title = `Rastreamento | ${cfg.nome_plataforma || 'Sigatron'}`;
            // Atualiza favicon
            if (cfg.logo_base64) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
                link.href = cfg.logo_base64;
            }
        } catch(e) {}
    };

    const tocarAlerta = () => {
        try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            [0, 150, 300].forEach(delay => {
                const o = ctx.createOscillator();
                const g = ctx.createGain();
                o.connect(g); g.connect(ctx.destination);
                o.frequency.value = 880;
                o.type = 'sine';
                g.gain.setValueAtTime(0.4, ctx.currentTime + delay/1000);
                g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay/1000 + 0.3);
                o.start(ctx.currentTime + delay/1000);
                o.stop(ctx.currentTime + delay/1000 + 0.3);
            });
        } catch(e) {}
    };

    const verificarNotificacoes = async () => {
        try {
            const res = await getNotificacoes(true);
            const count = res.data.length;
            if (count > pendentesRef.current && pendentesRef.current >= 0) {
                tocarAlerta();
            }
            pendentesRef.current = count;
            setPendentes(count);
        } catch(e) {}
    };

    useEffect(() => {
        const u = localStorage.getItem('usuario');
        if (u) setUsuario(JSON.parse(u));
        carregarConfiguracao();
    }, []);

    useEffect(() => {
        if (!usuario) return;
        verificarNotificacoes();
        const t = setInterval(verificarNotificacoes, 10000);
        return () => clearInterval(t);
    }, [usuario]);

    const sair = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        setUsuario(null);
    };

    if (!usuario) return <Login onLogin={setUsuario} configuracao={configuracao} />;

    const isAdmin = usuario.perfil === 'admin';

    return (
        <>
            {/* ── Navbar estilo iOS ── */}
            <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
                height: 52,
                background: 'rgba(255,255,255,0.88)',
                backdropFilter: 'saturate(180%) blur(20px)',
                WebkitBackdropFilter: 'saturate(180%) blur(20px)',
                borderBottom: '1px solid rgba(0,0,0,0.08)',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '0 16px',
                fontFamily: 'var(--ios-font)',
            }}>
                {/* Logo */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                    {configuracao.logo_base64 ? (
                        <img src={configuracao.logo_base64} alt="logo" style={{ width: 30, height: 30, borderRadius: 8, objectFit: 'contain' }} />
                    ) : (
                        <div style={{
                            width: 30, height: 30, borderRadius: 8,
                            background: 'linear-gradient(145deg, #1c1c1e, #3a3a3c)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        }}>
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 13 8 13s8-7.75 8-13c0-4.42-3.58-8-8-8z"
                                    fill="white" opacity="0.3"/>
                                <circle cx="12" cy="10" r="3.5" fill="white"/>
                            </svg>
                        </div>
                    )}
                    <span style={{ fontWeight: 700, fontSize: 16, color: '#1c1c1e', letterSpacing: -0.3 }}>
                        {configuracao.nome_plataforma || 'Sigatron'}
                    </span>
                </div>

                {/* Botões centrais */}
                <div style={{ display: 'flex', gap: 2 }}>
                    <NavBtn onClick={() => setShowHistorico(true)}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                            <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/>
                        </svg>
                        Histórico
                    </NavBtn>
                    <NavBtn onClick={() => setShowRelatorio(true)}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline points="14,2 14,8 20,8"/>
                            <line x1="8" y1="13" x2="16" y2="13"/>
                            <line x1="8" y1="17" x2="16" y2="17"/>
                        </svg>
                        Relatório
                    </NavBtn>
                    {isAdmin && <>
                        <NavBtn onClick={() => setShowEquipamentos(true)}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                                <rect x="5" y="2" width="14" height="20" rx="2"/>
                                <line x1="12" y1="18" x2="12" y2="18.01"/>
                            </svg>
                            Equipamentos
                        </NavBtn>
                        <NavBtn onClick={() => setShowCadastro(true)}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                                <rect x="1" y="3" width="15" height="13" rx="2"/>
                                <path d="M16 8h4l3 3v5h-7V8z"/>
                                <circle cx="5.5" cy="18.5" r="2.5"/>
                                <circle cx="18.5" cy="18.5" r="2.5"/>
                            </svg>
                            Veículos
                        </NavBtn>
                        <NavBtn onClick={() => setShowConfiguracoes(true)}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
                                <circle cx="12" cy="12" r="3"/>
                                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                            </svg>
                            Configurações
                        </NavBtn>
                    </>}
                </div>

                {/* Sino de notificações */}
                <button onClick={() => setShowNotificacoes(true)} style={{
                    position: 'relative', background: 'transparent', border: 'none', cursor: 'pointer',
                    padding: '6px 8px', borderRadius: 8, display: 'flex', alignItems: 'center',
                    transition: 'background 0.15s',
                }} onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,122,255,0.08)'}
                   onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={pendentes > 0 ? '#ff3b30' : '#3a3a3c'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                    </svg>
                    {pendentes > 0 && (
                        <span style={{
                            position: 'absolute', top: 2, right: 2,
                            background: '#ff3b30', color: 'white',
                            borderRadius: '50%', width: 16, height: 16,
                            fontSize: 10, fontWeight: 700,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            lineHeight: 1,
                        }}>{pendentes > 9 ? '9+' : pendentes}</span>
                    )}
                </button>

                {/* Usuário + Sair */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 13, color: '#636366', fontWeight: 400 }}>
                        {usuario.nome}
                    </span>
                    <span style={{
                        fontSize: 11, fontWeight: 600, borderRadius: 20, padding: '3px 9px',
                        background: isAdmin ? 'rgba(255,149,0,0.13)' : 'rgba(52,199,89,0.13)',
                        color: isAdmin ? '#e08600' : '#28a745',
                    }}>
                        {isAdmin ? 'Admin' : 'User'}
                    </span>
                    <button onClick={sair} style={{
                        background: 'transparent', border: '1px solid rgba(255,59,48,0.35)',
                        borderRadius: 8, padding: '5px 12px', cursor: 'pointer',
                        fontSize: 13, color: '#ff3b30', fontFamily: 'var(--ios-font)',
                        fontWeight: 500, transition: 'all 0.15s',
                    }}>
                        Sair
                    </button>
                </div>
            </div>

            <div style={{ paddingTop: 52 }}>
                <Mapa />
            </div>

            {showCadastro      && <Cadastro      onFechar={() => setShowCadastro(false)}      />}
            {showEquipamentos  && <Equipamentos  onFechar={() => setShowEquipamentos(false)}  />}
            {showConfiguracoes && <Configuracoes onFechar={() => setShowConfiguracoes(false)} onAtualizar={carregarConfiguracao} />}
            {showHistorico     && <Historico     onFechar={() => setShowHistorico(false)}     />}
            {showRelatorio     && <Relatorio     onFechar={() => setShowRelatorio(false)}     configuracao={configuracao} />}
            {showNotificacoes  && <Notificacoes  onFechar={() => { setShowNotificacoes(false); verificarNotificacoes(); }} />}
        </>
    );
}
